
import React, { useEffect, useState } from 'react'
import { Form, Link, NavLink, useNavigate } from 'react-router-dom'
import FloatingLabelInput from 'react-floating-label-input';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
// import { FcGoogle } from "react-icons/fc";
import TranslateIcon from '@mui/icons-material/Translate';

import { SignInImages } from '../config/imagesLink';
import WarningToast from "./WarningToast";
import ErrorToast from "./ErrorToast";
import SuccessToast from "./SuccessToast";
import axios from '../API/axios'
import { useTranslation } from 'react-i18next';
import { Button, Dropdown } from "react-bootstrap";

import i18n from '../i18n';
import { useFormik } from 'formik';
// import SignInImages from '../config/imagesLink'
const SetPassword = () => {
  const navigate = useNavigate();

    const [toastMessage, setToastMessage] = useState("");
    const [showToast, setShowToast] = useState(false);
          const language = localStorage.getItem("Lang");
   const { t } = useTranslation();
const [showPassword, setShowPassword] = useState(false);
  const [data, setData] = useState("false"); 

   const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
    const [warningToastMessage, setWarningToastMessage] = useState("");
    const [showWarningToast, setShowWarningToast] = useState(false);

    const [ErrorToastMessage, setErrorToastMessage] = useState("");
    const [showErrorToast, setShowErrorToast] = useState(false);

    //************************ Confirm Acount Start  ************************//
    const [mail, setMail] = useState('')
    const ConfirmAccount = async () => {
        const data = {
            deviceType: "Web",
            email: mail,
           langKey: language === "en" ? "" : language,

        };
        try {
            await axios.post("OAuth/ConfirmAccountByEmail", data).then((resData) => {
                console.log("resData", resData);
                setToastMessage(resData.data.message);
                setShowToast(true);
            });
        } catch (e) {
            if (e.response && e.response.status === 404) {
                setWarningToastMessage(e.response.data.message);
                setShowWarningToast(true);
            } else {
                setErrorToastMessage(e.response.data.message);
                setShowErrorToast(true);
            }
        }
    };
    //************************ Confirm Acount End  ************************//
  const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
        localStorage.setItem("Lang", lang);
    
        // document.body.dir = lang === "ar" ? "rtl" : "ltr"; // RTL for Arabic
      };

    const [ConnectionListForGuest, setConnectionListForGuest] = useState("");
      const ConnectionListAllForGuest = async (id) => {
        try {
          await axios
            .get("UserFollow/GetMostFollowingUser?DeviceType=Web")
            .then((resData) => {
              // console.log("ConnectionListAllForGuest", resData.data.responseData);
              setConnectionListForGuest(resData.data.responseData);
            });
        } catch (error) {
          console.log(error);
        }
      }; 
      useEffect(() => {
        ConnectionListAllForGuest();
      }, []);
      const [guestMode, setGuestMode] = useState(false);
      const LinktoGuest = () => {
        setGuestMode(true);
        localStorage.setItem("guestMode", "true");
      };


       const [loading, setLoading] = useState(false);
        const initialValues = {
        //   email: localStorage.getItem("user-email") || "",
        //   password: "",
        };
      
        const { values, errors, handleBlur, touched, handleChange, handleSubmit } =
          useFormik({
            // initialValues,
            // validationSchema: loginValidations,
            onSubmit: async () => {
              setLoading(true);
              const RegisterData = {
                deviceType: "Web",
                // email: values.email,
                // password: values.password,
                langKey: language === "en" ? "" : language,
              };
              try {
                const res = await axios.post("OAuth/LoginWithEmail", RegisterData, {
                  headers: {
                    // PublicKey,
                  },
                });
            //   navigate("/NewsFeed");
                // setTimeout(() => {
                // }, 500);
              } catch (error) {
                if (error.response && error.response.status === 403) {
                 console.log("eeeeeee");
                 
                }
              } finally {
                // setLoading(false);
              }
            },
          });

    return (
        <>
            <style>
                    {
                      `.language-dropdown .dropdown-menu {
                        transform: none !important;
                        inset: auto !important;
                        right: 10px !important;
                        bottom: 40px !important;
                }
            `
                    }
                  </style>
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-md-8 full-height p-2 loginImage">
                        <div className="bg-cover">
                          <div className="imageData">
                            <div className="text-center">
                              <img src={SignInImages.whiteLogo} alt="" />
                            </div>
                            <p>
                              {t("SignIn.Stay connected for")} <NavLink
                                to={`/SearchJob`}
                                onClick={LinktoGuest}
                                className="border-bottom"
                              >
                                {t("Company Profile.Jobs")} </NavLink>{" "}
                              {t("SignIn.and")} <NavLink
                                to={`/NewsFeed`}
                                onClick={LinktoGuest}
                                className="border-bottom"
                              >
                                {t("SignIn.More")}
                              </NavLink>
                            </p>
                     
                            <div className="userLink text-center mt-2 d-flex justify-content-center">
                              <Link to="/People" onClick={LinktoGuest}>
                                <div className="circle-container">
                                  {ConnectionListForGuest &&
                                    ConnectionListForGuest?.slice(0, 3).map(
                                      (user, userIndex) => (
                                        <img
                                          src={user?.profilPic}
                                          alt={`Circle ${userIndex + 1}`}
                                          className="circle-img"
                                          key={userIndex}
                                        />
                                      )
                                    )}
                                </div>
                              </Link>
                              <span className="f-14 fw-bold">
                               {t("SignIn.15k+ people joined us, now it's your turn")}
                              </span>
                              {/* <img src={SignInImages.ovalwithtext} alt="" width="80%" /> */}
                            </div>
                            
                          </div>
                          <div className="linksHelp">
                            <p>
                              <a href="/privacy-policy.html" target="_blank">
                                {t("Sidemenubar.Privacy Policy")}
                              </a>{" "}
                              |{" "}
                              <a href="/terms-and-conditions.html" target="_blank">
                               {t("Sidemenubar.Terms & Conditions")}
                              </a>
                            </p>
                            <p className="d-flex">
                             {t("SignIn.Having Troubles")}? <a
                                href="/faq.html"
                                className="border-bottom me-3"
                                target="_blank"
                              >
                                {t("SignIn.Get Help")}
                              </a>{" "}
                               <Dropdown className="language-dropdown">
                                  <Dropdown.Toggle
                                    id="language-toggle"
                                    variant="link"
                                    className="text-decoration-none p-0 d-flex align-items-center language-btn"
                                  >
                                    {/* <Globe size={18} className="me-1" /> */}
                                  <TranslateIcon className="material-symbols-sharp me-3" style={{left: "20%", fill: "white"}}/>
                                    {/* <span>{t("Language")}</span> */}
                                  </Dropdown.Toggle>
                            
                                  <Dropdown.Menu align="end">
                                    <Dropdown.Item as="button" onClick={() => changeLanguage("en")}>
                                      En
                                    </Dropdown.Item>
                                    <Dropdown.Item as="button" onClick={() => changeLanguage("hi")}>
                                      Hi 
                                    </Dropdown.Item>
                                    <Dropdown.Item as="button" onClick={() => changeLanguage("ar")}>
                                      Ar
                                    </Dropdown.Item>
                                  </Dropdown.Menu>
                               </Dropdown>
                            </p>
                          </div>
                        </div>
                      </div>
                       <div className="col-lg-4 col-md-6 Login-Section">
                                   <div className="form-container pb-3">
                                      
                                     <Form
                                    //   onSubmit={handleSubmit}
                                       className="formBorder p-1">
                                        
                                       
                                       <div className="password-input border-signIn d-flex align-items-baseline">
                                         <FloatingLabelInput
                                           id="password"
                                           label={t("SignIn.Password")}
                                           type={showPassword ? "text" : "password"}
                                           name="password"
                                        //    value={values.password}
                                           onChange={handleChange}
                                           onBlur={handleBlur}
                                         />
                                         <div
                                           className="password-toggle"
                                           onClick={togglePasswordVisibility}
                                         >
                                           {showPassword ? <FaEyeSlash /> : <FaEye />}
                                         </div>
                                       </div>
                                       {/* {errors.password && touched.password && (
                                         <p className="form-error" style={{ color: "red" }}>
                                           {errors.password}
                                         </p>
                                       )} */}
                                       <div className="password-input border-signIn d-flex align-items-baseline">
                                         <FloatingLabelInput
                                           id="password"
                                           label={t("SignIn.Password")}
                                           type={showPassword ? "text" : "password"}
                                           name="password"
                                        //    value={values.password}
                                           onChange={handleChange}
                                           onBlur={handleBlur}
                                         />
                                         <div
                                           className="password-toggle"
                                           onClick={togglePasswordVisibility}
                                         >
                                           {showPassword ? <FaEyeSlash /> : <FaEye />}
                                         </div>
                                       </div>
                                       {/* {errors.password && touched.password && (
                                         <p className="form-error" style={{ color: "red" }}>
                                           {errors.password}
                                         </p>
                                       )} */}
                                       
                                     </Form>
                                       
                                     
                        
                                   </div>
                                 </div>
                    </div>
                  </div>

            <SuccessToast
                show={showToast}
                message={toastMessage}
                onClose={() => setShowToast(false)}
            />

            <WarningToast
                show={showWarningToast}
                message={warningToastMessage}
                onClose={() => setShowWarningToast(false)}
            />

            <ErrorToast
                show={showErrorToast}
                message={ErrorToastMessage}
                onClose={() => setShowErrorToast(false)}
            />
        </>
    )
}

export default SetPassword